import React, { Component } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment-timezone';
import { formatToCurrency } from '../../../../Tools/formatToCurrency';
import {errorHandle} from "../../../Common/errorHandle";
import quickbook from '../../../../Assets/images/quickbook.png';
class AccountSidebar extends Component {
  state = {
    monthly_forecast_total: 0,
    SalesByItem: [],
    filter_date: moment(),
    uuid: '',
    work_orders: {},
    loader: false,
    user_role: ""
  }

  componentDidMount = () => {
    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser"))
      : "";
    if(user) {
      const uuid = user?.user?.associated_field_offices?.[0]?.uuid;
      this.setState({
        uuid: uuid
      })
    }
    const month = moment().format('MM');
    const year = moment().format('YYYY');

    this.props.getMonthlyForecastTotal({ created_at__month:month, created_at__year: year });
    this.props.getOverViewInvoice({ invoice_date__month: month, invoice_date__year: year });

    if(user?.user.role[0] === "franchise_owner")
    {
      this.props.getWorkOrdersSummary({
        scheduled_time__month: month,
        scheduled_time__year: year,
        status: "cancelled,complete",
        field_office__uuid: user?.user?.associated_field_offices?.[0]?.uuid
      });
    }
    else
      this.props.getWorkOrdersSummary({
        scheduled_time__month: month,
        scheduled_time__year: year,
        status: "cancelled,complete"
      });
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (Object.keys(props.InvoiceOverView.data).length > 0 && props.InvoiceOverView.data !== this.props.InvoiceOverView.data) {
      this.setState({
        InvoiceOverView: props.InvoiceOverView.data
      })
    }
    if (Object.keys(props.MonthlyForecastTotal).length > 0 && props.MonthlyForecastTotal.data !== this.props.MonthlyForecastTotal.data) {
      this.setState({ monthly_forecast_total: props.MonthlyForecastTotal.data});
    }
    if (Object.keys(props.InvoiceOverView.errors).length > 0 && props.InvoiceOverView.errors !== this.props.InvoiceOverView.errors) {
      // display error messsage
      errorHandle(props.InvoiceOverView.errors)
      this.setState({ loader: false })
    }

    if (Object.keys(props.GetQuickbooksSync.data).length > 0 && props.GetQuickbooksSync.data !== this.props.GetQuickbooksSync.data) {
      this.setState({
        loader: false
      })
    }
    if (Object.keys(props.GetQuickbooksSync.errors).length > 0 && props.GetQuickbooksSync.errors !== this.props.GetQuickbooksSync.errors) {
      // display error messsage
      errorHandle(props.GetQuickbooksSync.errors)
      this.setState({ loader: false })
    }
    if(props.WorkOrdersSummary?.data && Object.keys(props.WorkOrdersSummary?.data).length > 0 && props.WorkOrdersSummary?.data !== this.props.WorkOrdersSummary?.data) {
      this.setState({work_orders: props.WorkOrdersSummary.data.results});
    }
  }

  quickbooksForceSync = () => {
    this.props.getQuickbooksSync({
      uuid: this.state.uuid
    })
  }

  render() {
    let { filter_date, InvoiceOverView, monthly_forecast_total, work_orders } = this.state;
    return (
      <aside className="laside">
        <h3>Accounting Summary</h3>
        <div className="form-group">
          <div className="fitem">
            <DatePicker
              className="swhite summry_date_picker"
              format="MMM YYYY"
              picker="month"
              defaultValue={moment()}
              onChange={(e) => {
                this.setState({
                  filter_date: e
                })

                this.props.setData(e)
                const selected_month = moment(e).format('MM');
                const selected_year = moment(e).format('YYYY');
                
                this.props.getMonthlyForecastTotal({ created_at__month: selected_month, created_at__year: selected_year });
                this.props.getOverViewInvoice({ invoice_date__month: selected_month, invoice_date__year: selected_year });
                this.props.getWorkOrdersSummary({ scheduled_time__month: selected_month, scheduled_time__year: selected_year });
              }}
              placeholder=""
              allowClear={false}
              suffixIcon={<i className="las la-angle-down"></i>} />
          </div>
        </div>

        <div className="gray_box">
          <div className="card-body">
            <div className="flex">
              <div className="flex-1">
                <h4 className="mb-0">All Invoices</h4>
                <h6 className="mb-0 grey">{moment(filter_date).format('MMM, YYYY')}</h6>
              </div>
              <div className="flex-1">
                <h2 className="text-right">{InvoiceOverView?.invoices ? `$ ${formatToCurrency(InvoiceOverView?.invoices)}` : '-'}</h2>
              </div>
            </div>
            <div className="flex">
              <div className="label">
                <h6>Recurring Services</h6>
                <h6>Product Sales</h6>
                <h6>Commission</h6>
              </div>
              <div className="value">
                <h6>{InvoiceOverView?.recurring_service ? `$ ${formatToCurrency(InvoiceOverView?.recurring_service)}` : '-'}</h6>
                <h6>{InvoiceOverView?.product_sales ? `$ ${formatToCurrency(InvoiceOverView?.product_sales)}` : '-'}</h6>
                <h6>{InvoiceOverView?.commission ? `$ ${formatToCurrency(InvoiceOverView?.commission)}` : '-'}</h6>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <h6 className="mb-0 text-center pointer" onClick={() => { this.props.ChangeComponent(3) }}><u>Jump to Accounts Receivable Aging Summary</u></h6>
          </div>
        </div>

        <div className="gray_box">
          <div className="card-body">
            <div className="flex">
              <div className="flex-1">
                <h4 className="mb-0">Sales Tax</h4>
                <h6 className="mb-0 grey">{moment(filter_date).format('MMM, YYYY')}</h6>
              </div>
              <div className="flex-1">
                <h2 className="text-right">{InvoiceOverView?.sales_tax ? `$ ${formatToCurrency(InvoiceOverView?.sales_tax)}` : '0.00'}</h2>
              </div>
            </div>
            <div className="flex">
              <div className="label">
                <h6>Product Tax</h6>
                <h6>Service Tax</h6>
              </div>
              <div className="value">
                <h6>{InvoiceOverView?.product_tax ? `$ ${formatToCurrency(InvoiceOverView?.product_tax)}` : '0.00'}</h6>
                <h6>{InvoiceOverView?.service_tax ? `$ ${formatToCurrency(InvoiceOverView?.service_tax)}` : '0.00'}</h6>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <h6 className="mb-0 text-center pointer" onClick={() => { this.props.ChangeComponent(7) }} ><u>Jump to Sales Tax</u></h6>
          </div>
        </div>

        <div className="gray_box">
          <div className="card-body">
            <div className="flex">
              <div className="flex-1">
                <h4 className="mb-0">Monthly Forecast</h4>
                <h6 className="mb-0 grey">{moment(filter_date).format('MMM, YYYY')}</h6>
              </div>
              <div className="flex-1">
                <h2 className="text-right">{monthly_forecast_total ? `$ ${formatToCurrency(monthly_forecast_total)}` : '-'}</h2>
              </div>
            </div>
            <p>This shows services and products fulfilled, but are due to be invoiced on the next cycle.</p>
          </div>
          <div className="card-footer">
            <h6 onClick={() => { this.props.ChangeComponent(4) }} className="mb-0 text-center pointer"><u>Jump to Unbilled Work Report</u></h6>
          </div>
        </div>

        {/* Work Orders */}
        <div className="gray_box">
          <div className="card-body">
            <div className="flex">
              <div className="flex-1">
                <h4 className="mb-0">Work Orders</h4>
                <h6 className="mb-0 grey">{moment(filter_date).format('MMM, YYYY')}</h6>
              </div>
              <div className="flex-1">
                <h2 className="text-right">{work_orders?.total ? `$ ${formatToCurrency(work_orders?.total)}` : '-'}</h2>
              </div>
            </div>
            <p style={{"textAlign": "justify"}}>
              View all work orders from this period (Includes WO(s) of all statuses). The total refers only for WO(s) ready to be batch invoiced.
            </p>
          </div>
          <div className="card-footer">
            <h6 onClick={() => { this.props.ChangeComponent(8) }} className="mb-0 text-center pointer"><u>Jump to Work Orders</u></h6>
          </div>
        </div>

        <div className="mt-10">
          <h6 className="mb-0">Other Reports</h6>
          <u className="pointer" onClick={() => { this.props.ChangeComponent(2) }}><b>Sales by Item Breakdown</b></u><br />
          <u className="pointer" onClick={() => { this.props.ChangeComponent(1) }}><b>Expiring Customer Payment Methods</b></u>
        </div>

        <div className="syncbook">
          <img src={quickbook} alt="" />
          <u className="mt-10 d-block pointer" onClick={() => { this.quickbooksForceSync()}}><b>Force Resync with Quickbooks</b></u>
        </div>
      </aside>
    );
  }
}

export default AccountSidebar;